import { Button } from "react-bootstrap";
import { VscEdit } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import IconText from "./IconText";

const EditButton = ({ url = null, onClick = null }) => {
  const navigate = useNavigate();
  return (
    <Button
      variant="default"
      size="sm"
      onClick={() => (onClick ? onClick() : navigate(url))}
    >
      <IconText icon={<VscEdit />} />
    </Button>
  );
};

export default EditButton;
